import { render, staticRenderFns } from "./120.vue?vue&type=template&id=462f3b82&scoped=true&"
var script = {}
import style0 from "./120.vue?vue&type=style&index=0&id=462f3b82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462f3b82",
  null
  
)

export default component.exports